import { render, staticRenderFns } from "./myAgencyProduct.vue?vue&type=template&id=b448289a&"
import script from "./myAgencyProduct.vue?vue&type=script&lang=js&"
export * from "./myAgencyProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports